import { getAnalytics, logEvent, setCurrentScreen } from 'firebase/analytics';

const analytics = getAnalytics();

export const logAnalyticsEvent = (eventName: string, eventData: any) => {
  logEvent(analytics, eventName, eventData);
};

export const setAnalyticsScreenName = (screenName: string) => setCurrentScreen(analytics, screenName);
